// import { datadogRum } from '@datadog/browser-rum'; // Removed: @datadog/browser-rum package removed
// import { DD_LOGS } from '@datadog/browser-logs';

const debug = false; // Set to true for debugging

/**
 * Logs a Datadog RUM action for canvas performance events
 */

export function trackCanvasMetric(metricName, data = {}) {
  try {
    // datadogRum.addAction(`${metricName}`, data); // Removed: @datadog/browser-rum package removed
    if (debug) {
      console.log(`${metricName}`, data);
    }
  } catch (error) {
    console.warn('Failed to send RUM metric:', error);
  }
}

/**
 * Logs structured canvas messages to Datadog Logs Explorer
 */
function logCanvas(
  level,
  message,
  {
    error = null,
    creationId = null,
    slideId = null,
    userId = null,
    tpUser = null,
    location = '',
    objectCount = null,
    extra = {},
  } = {},
) {
  //   if (!DD_LOGS?.logger?.[level]) return; // DO NOT DELETE

  const context = {
    creationId,
    slideId,
    userId,
    tpUser,
    location,
    objectCount,
    ...extra,
  };

  if (error instanceof Error) {
    context.errorMessage = error.message;
    context.errorStack = error.stack;
  }

  //   DD_LOGS.logger[level](message, context);
  console[level](message, context); // fallback to console logging
}

// Public log methods
export const logCanvasError = (msg, ctx) => logCanvas('error', msg, ctx);
export const logCanvasWarn = (msg, ctx) => logCanvas('warn', msg, ctx);
export const logCanvasInfo = (msg, ctx) => logCanvas('info', msg, ctx);
